export default "__VITE_ASSET__wyNbFPhW__"